module.exports = __webpack_public_path__ + "img/qxbj.98c630c0.png";